import { render, staticRenderFns } from "./AttributeSection.vue?vue&type=template&id=1ce5a5fa&"
import script from "./AttributeSection.vue?vue&type=script&lang=js&"
export * from "./AttributeSection.vue?vue&type=script&lang=js&"
import style0 from "./AttributeSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports